/**
 * Tool tips v1.5
 */
(function($) {
    let c24TipsCurrent = null;
    $.fn.c24Tips = function(settings) {
        let oTip;
        let oCurrent = null;
        let oTimeOut = false;
        let bClicked = false;
        let bShow = false;
        let oSettings;

        // Default settings
        $.c24Tips = {
            defaults: {
                top: 15,
                bottom: 15,
                left: 15,
                maxWidth: 200,
                width: 'auto',
                align: '',
                id: 'tips',
                className: 'box24Tip',
                dataTag: false,
                textSource: false,
                text: false,
                showOnClick: false,
                showOnHover: true,
                delayTime: false,
                showDelay: 0,
                fixedPosition: false,
                responsive: false,
                lockElement: false,
                groupName: false,
                fadeSpeed: false,
                mobile: 'auto',
                close: true,
                nose: false,
            },
            mobile: {
                showOnClick: true,
                showOnHover: false,
                showDelay: 0,
                delayTime: false,
                close: true,
            },
        };

        // Updates default settings with the user settings
        oSettings = $.extend({}, $.c24Tips.defaults, settings);

        // If mobile is auto checks if window.c24MobileDevice is set...
        if (oSettings.mobile == 'auto') {
            if (typeof window.c24MobileDevice !== 'undefined') oSettings.mobile = window.c24MobileDevice;
            else oSettings.mobile = false;
        }

        // If mobile disable some settings that make no sence :)
        if (oSettings.mobile) {
            oSettings = $.extend({}, oSettings, $.c24Tips.mobile);
        }

        // If Tip object exists... create new unique id
        if ($('#' + oSettings.id).length) {
            let i = 1;
            while ($('#' + oSettings.id + i).length) {
                i++;
            }
            oSettings.id = oSettings.id + i;
        }

        // Creates the Tip
        oTip = $('<div id="' + oSettings.id + '" class="' + oSettings.className + ' ' + oSettings.groupName + '"></div>').appendTo(document.body).hide();
        $(window).on('resize scroll', function() { oTip.hide(); });

        if (oSettings.close) {
            $(document).on('click', '#' + oSettings.id + ' ' + '.ico24Close', function() {
                oTip.hide(true);
            });
        }

        this.each(function() {
            if (oSettings.text) this.tiptext = oSettings.text;
            else if (oSettings.dataTag && $(this).data(oSettings.dataTag)) this.tiptext = $(this).data(oSettings.dataTag);
            else if (oSettings.textSource) {
                this.tiptext = $(oSettings.textSource, this).html();
                oSettings.nose = true;
            } else this.tiptext = this.title;

            if (oSettings.nose) this.tiptext = '<div class="div24Nose"></div>' + this.tiptext;
            if (oSettings.close) {
                this.tiptext = '<div class="ico24Close"></div>' + this.tiptext;
                //$('.ico24Close', this).on('click', function() {oTip.hide();});
            }

            this.linked = $(this);

            $(this).removeAttr('title alt');

            if (oSettings.showOnClick) {
                $(this).click(function(event) {
                    if (this != oCurrent) {
                        bClicked = true;
                        const e = this;
                        setTimeout(function() {
                            oCurrent = e;
                            oTip.html(e.tiptext);
                            // $('.ico24Close', '#'+oSettings.id).on('click', function() {oTip.hide();});
                            if (oSettings.fadeSpeed) oTip.stop().fadeIn(oSettings.fadeSpeed);
                            else oTip.show();
                            handle(event);
                        }, 100);
                    } else {
                        hide();
                    }
                });
            }

            if (oSettings.showOnHover) {
                $(this).mouseover(function() {
                    if (!bClicked && !bShow) {
                        c24TipsCurrent = this;
                        start(this);
                    }
                }).mouseout(function() {
                    if (!bClicked && bShow) {
                        hide();
                    }
                });
                $('#' + oSettings.id).mouseout(function() {
                    if (!bClicked && oSettings.showOnHover && oSettings.fixedPosition && bShow) {
                        hide();
                    }
                });
            }
        });

        // Hides on document click
        if (oSettings.showOnClick) {
            $(document).click(hide);
        }

        function handle(event) {
            if (oSettings.fadeSpeed) oTip.stop().fadeIn(oSettings.fadeSpeed);
            else oTip.show();
            if (oSettings.showOnHover) {
                if (oSettings.fixedPosition == false) $(document.body).on('mousemove', update);
            }
            update(event);
        }

        function start(event) {
            if (event == oCurrent || !event.tiptext || bShow) return;
            setTimeout(function() {
                if (c24TipsCurrent == event && $(event).is(':hover')) {
                    oCurrent = event;
                    oTip.html(event.tiptext);
                    //$('.ico24Close', '#'+oSettings.id).on('click', function() {oTip.hide();});
                    handle.apply(event);
                    bShow = true;
                }
            }, oSettings.showDelay);
        }

        function update(event) {
            oTip.removeClass('placeLeft placeRight placeBottom placeTop');
            oTip.css('width', '');
            let width = oSettings.width;
            let left = oTip[0].offsetLeft;
            let top = oTip[0].offsetTop;
            let bottom = oTip[0].offsetBottom;
            const thisWidth = oTip.width();
            let right = 'auto';

            if (event && !oSettings.lockedObject && (!oSettings.posX || !oSettings.posY)) {
                left = event.pageX + oSettings.left;
                top = event.pageY + oSettings.top;
                bottom = event.pageY - (oTip.height() + oSettings.bottom);
                if (oSettings.maxWidth && thisWidth > oSettings.maxWidth) {
                    width = oSettings.maxWidth;
                }

                if (oSettings.align == 'left') {
                    right = $(window).width() - left;
                    left = 'auto';
                }
            }

            if (oSettings.lockElement) {
                const lockPosition = $(oSettings.lockElement).offset();
                left = lockPosition.left + oSettings.left;
                top = lockPosition.top + oSettings.top;
            } else if (oSettings.fixedPosition) {
                const lockPosition = oCurrent.linked.offset();
                left = lockPosition.left + oSettings.left;
                top = lockPosition.top + oSettings.top;
            }

            oTip.css({
                left: left,
                right: right,
                top: top,
                width: width,
            });

            // Only adds class when not fixe position
            if (!oSettings.fixedPosition) {
                const windowx = $(window).scrollLeft() + $(window).width();
                const windowy = $(window).scrollTop() + $(window).height();

                if (windowx < oTip[0].offsetLeft + oTip[0].offsetWidth && !oSettings.lockElement) {
                    left -= oTip[0].offsetWidth + 4 + oSettings.left;
                    oTip.css('left', left);
                    oTip.addClass('placeRight');
                } else {
                    oTip.addClass('placeLeft');
                }
                if (windowy < oTip[0].offsetTop + oTip[0].offsetHeight && !oSettings.lockElement) {
                    top -= oTip[0].offsetHeight + oSettings.top;
                    oTip.css('top', bottom);
                    oTip.addClass('placeTop');
                } else {
                    oTip.addClass('placeBottom');
                }
            } else if (oSettings.responsive) {
                const windowx = $(window).scrollLeft() + $(window).width();
                let change = false;

                if (oTip[0].offsetLeft < 0) {
                    left = 0;
                    change = true;
                } else if (oTip[0].offsetLeft + oTip[0].offsetWidth > windowx) {
                    left = windowx - oTip[0].offsetWidth;
                    change = true;
                }

                if (change) {
                    oTip.find('.div24Nose').remove();
                    oTip.css({
                        left: left,
                        right: right,
                        top: top,
                        width: width,
                    });
                }
            }
        }

        function hide(force) {
            if (oSettings.delayTime && !bClicked) {
                oTimeOut = setTimeout(function() {
                    doHide(force);
                }, oSettings.delayTime);
                // doHide(true);
            } else {
                bClicked = false;
                doHide(true);
            }
        }

        function doHide(force) {
            if (force || ((!$('#' + oSettings.id).is(':hover') && (oCurrent != null && !$(oCurrent).is(':hover'))) || !oSettings.fixedPosition)) {
                if (oSettings.fadeSpeed) oTip.stop().fadeOut(oSettings.fadeSpeed);
                else oTip.hide();
                oCurrent = null;
                $(document.body).off('mousemove', update);
                bShow = false;
                bClicked = false;
            }
            clearTimeout(oTimeOut);
        }
    };
})(jQuery);
